import { RegisterForm } from '@/features/consumer/register-form';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/(consumer)/_auth-layout/register')({
  component: RouteComponent,
});

function RouteComponent() {
  return <RegisterForm />;
}
